import * as R from 'ramda';
import { simpleXmlToJson } from 'system/libs/simpleXmlToJson';
import { randomHelper } from 'utils/randomHelper';
import { HttpMethods } from 'utils/Types';

import RPC from 'RPC';

const API_VERSION = 1;

const API_PREFIX = `/api/v${API_VERSION}/`;

const _handleUrl = (url) => {
    const openstackUrlRegex = /^\/infra\/.+$/;
    const consistPrefixRegex = /^\/api\/v[^/]+.+$/;
    const fullUrlRegex = /^https?:\/\/.+$/;

    if (
        [openstackUrlRegex, consistPrefixRegex, fullUrlRegex].some((regex) =>
            regex.test(url),
        )
    ) {
        return url;
    }
    return `${API_PREFIX}${_removeLeadingSlash(url)}`;
};

const _removeLeadingSlash = (url) => url.replace(/^\/(.+)/, '$1');

type Response<T> = {
    body: T;
};

async function rpcCall<Body>(arg: {
    url: string;
    method?: HttpMethods;
    data?: Record<string, any>;
    apiVersioning?: boolean;
    clearEmptyValues?: boolean;
    options?: any;

    returnRawResponse?: false;
}): Promise<Body>;
async function rpcCall<Body>(arg: {
    url: string;
    method?: HttpMethods;
    data?: Record<string, any>;
    apiVersioning?: boolean;
    clearEmptyValues?: boolean;
    options?: any;

    returnRawResponse: true;
}): Promise<Response<Body>>;
async function rpcCall(arg): Promise<any> {
    const {
        url,
        method = 'GET',
        returnRawResponse = false,
        apiVersioning = true,
        clearEmptyValues,
        options,
    } = arg;
    const handledUrl = apiVersioning ? _handleUrl(url) : url;
    const { version, baseUrl } = RPC.setup();

    if (!apiVersioning) {
        // RPC.call автоматически дополняет endpoint
        // следующим образом `${baseUrl}/v${version}/${endpoint}`
        RPC.setup({
            version: false,
            baseUrl: '/',
        });
    }

    let { data } = arg;
    if (clearEmptyValues) {
        data = R.reject(
            (value: any) => ['', null, undefined].includes(value),
            data,
        );
    }

    const request = RPC.call(handledUrl, data, { type: method, ...options });

    if (!apiVersioning) {
        RPC.setup({
            version,
            baseUrl,
        });
    }

    const response = await request;

    return returnRawResponse ? response : response.body;
}

const loadText = async (url, data = {}) => {
    // @ts-ignore
    data._ = randomHelper.getRandomInt(1000000000000, 9999999999999);
    return rpcCall<string>({
        url,
        options: {
            dataType: 'text',
        },
        data,
        apiVersioning: false,
    });
};

const loadXml = async <T>(url, data = {}) => {
    // @ts-ignore
    data._ = randomHelper.getRandomInt(1000000000000, 9999999999999);
    const xml = await rpcCall<string>({
        url,
        options: {
            dataType: 'xml',
        },
        data,
        apiVersioning: false,
    });

    return simpleXmlToJson(xml) as T;
};

export const ApiHelper = {
    loadText,
    loadXml,
    rpcCall,
};
